import Vue from 'vue'
import Vuex from 'vuex'
import HomeService from '../services/homeService'
import kkUtil from '../assets/js/kk-util'
import userService from '../services/userService'

Vue.use(Vuex)
let commonInfo = window.localStorage.getItem('$_common_info')
let bookSearch = window.localStorage.getItem('$_book_search')
try {
  commonInfo = commonInfo && JSON.parse(commonInfo)
  bookSearch = bookSearch && JSON.parse(bookSearch)
} catch (error) {

}

const store = new Vuex.Store({
  state: {
    pageState: {},
    commonInfo: commonInfo || {},
    bookSearch: bookSearch || {
      hotWords: []
    },
    readList: [],
    homeData: null
  },
  mutations: {
    saveState (state, current) {
      for (const key in current) {
        state.pageState[key] = current[key]
      }
    },
    saveCommonInfo (state, data) {
      state.commonInfo = data
      window.localStorage.setItem('$_common_info', JSON.stringify(data))
    },
    saveBookSearch (state, data) {
      state.bookSearch = data
      window.localStorage.setItem('$_book_search', JSON.stringify(data))
    },
    setHistoryReadList (state, list) {
      state.readList = list
    },
    saveHomeData (state, data) {
      state.homeData = data
    }
  },
  actions: {
    fetchCommonInfo ({ commit }) {
      // 这里加载优先于beforeCreate，所以需要单独获取
      let branchId = kkUtil.getQueryStr('fcid')
      if (branchId) {
        if (branchId.charAt(branchId.length - 1) === '/') {
          branchId = branchId.substring(0, branchId.length - 1)
        }
        userService.setBranchId(branchId)
      }
      HomeService.getCommonInfo().then(res => {
        if (res.result) {
          commit('saveCommonInfo', res.data)
        }
      })
    },
    fetchBookSearch ({ commit }) {
      // 这里加载优先于beforeCreate，所以需要单独获取
      let branchId = kkUtil.getQueryStr('fcid')
      if (branchId) {
        if (branchId.charAt(branchId.length - 1) === '/') {
          branchId = branchId.substring(0, branchId.length - 1)
        }
        userService.setBranchId(branchId)
      }
      HomeService.bookInitSearch().then(res => {
        if (res.result) {
          const resData = res.data
          const hotWords = resData.hotWords || []
          commit('saveBookSearch', { hotWords })
        }
      })
    }
  },
  getters: {
    getCommonInfo (state) {
      return state.commonInfo
    },
    getBookSearch (state) {
      return state.bookSearch
    },
    getHistoryReadList (state) {
      return state.readList
    },
    getHomeData (state, data) {
      return state.homeData
    }
  }
})

export default store
